// extracted by mini-css-extract-plugin
export default {"aws-icon":"Styles_aws-icon__ox6ME","azure-icon":"Styles_azure-icon__vFbqS","on-prem-icon":"Styles_on-prem-icon__ghXg+","gcp-icon":"Styles_gcp-icon__R0g0L"};